import "@esri/calcite-components/components/calcite-loader";
import UploadModel from "./UploadModel.jsx";
import SampleModel from "./SampleModel.jsx";
import DownloadModel from "./DownloadModel.jsx";

import {  useState } from "react";


function UploadBuilding({setProjectListInput}) {
  const [model, setModel] = useState(null);
  return (
    <>
      <UploadModel onChange={setModel} setProjectListInput={setProjectListInput} />
      <SampleModel onChange={setModel} />
      <DownloadModel model={model} />      
    </>
  );
}

export default UploadBuilding;
